import { TextRegular } from 'UiKit/typography';
import styles from './styles.module.css';

const getTableList = (t) => [
  {
    name: <span className={styles['list-stock-detail__column--title']}>{t('stock_detail.warehouse')}</span>,
    key: 'name',
    width: '70%',
    position: 'left',
    component: ({ value, values }) => {
      const isActive = values?.isActive;
      const background = isActive ? '#e7f1ff' : '#f1f1f1;';
      const color = isActive ? ' var(--color-primary70);' : 'var(--color-semantic-text)';
      return (
        <TextRegular background={background} color={color} className={`${styles['table-stock__cell--warehouse-text']}`}>
          {value}
        </TextRegular>
      );
    },
  },
  {
    name: <TextRegular className={styles['list-stock-detail__column--title']}>{t('stock_detail.stock')}</TextRegular>,
    key: 'stock',
    width: '30%',
    position: 'left',
    component: ({ value }) => {
      return <TextRegular className={styles['table-stock__cell--stock-text']}>{value}</TextRegular>;
    },
  },
];

export default getTableList;
